import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import OptionMenu from "./OptionMenu";
import TextArea from "./TextArea";
import MultipleSelect from "./MultipleSelect";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RichTextEditor from './RichTextEditor';
const ContentMain = () => {
  const [active, setActive] = useState(false);
  return (
    <div className="content">
      <div className="content-header">
        <ul className="content-nav">
          <li>
            <Link
              to=""
              className={active ? "active" : ""}
              onClick={() => setActive(!active)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="sidebar-menu__icons"
              >
                <path
                  d="M13.3778 0.666687H2.62225C2.10405 0.66816 1.60744 0.874657 1.24111 1.24111C0.874651 1.60744 0.668164 2.10405 0.666687 2.62225V13.3778C0.66816 13.896 0.874658 14.3926 1.24111 14.7589C1.60744 15.1254 2.10405 15.3319 2.62225 15.3334H13.3778C13.896 15.3319 14.3926 15.1254 14.7589 14.7589C15.1254 14.3926 15.3319 13.896 15.3334 13.3778V2.62225C15.3319 2.10405 15.1254 1.60744 14.7589 1.24111C14.3926 0.874651 13.896 0.668164 13.3778 0.666687ZM3.13076 3.28706H12.2438C12.4683 3.28706 12.6756 3.40688 12.7878 3.60122C12.9001 3.79557 12.9001 4.0351 12.7878 4.22942C12.6756 4.42376 12.4683 4.54359 12.2438 4.54359H3.13076C2.90634 4.54359 2.699 4.42376 2.58667 4.22942C2.47446 4.03508 2.47446 3.79555 2.58667 3.60122C2.699 3.40688 2.90636 3.28706 3.13076 3.28706ZM3.13076 5.80001H12.2438C12.4683 5.80001 12.6756 5.91971 12.7878 6.11417C12.9001 6.30852 12.9001 6.54792 12.7878 6.74237C12.6756 6.93671 12.4683 7.05641 12.2438 7.05641H3.13076C2.90634 7.05641 2.699 6.93671 2.58667 6.74237C2.47446 6.5479 2.47446 6.3085 2.58667 6.11417C2.699 5.91971 2.90636 5.80001 3.13076 5.80001ZM7.52576 12.087H3.13076C2.90634 12.087 2.699 11.9673 2.58667 11.773C2.47446 11.5786 2.47446 11.3391 2.58667 11.1448C2.699 10.9503 2.90636 10.8306 3.13076 10.8306H7.52576C7.75018 10.8306 7.95765 10.9503 8.06985 11.1448C8.18206 11.3391 8.18206 11.5786 8.06985 11.773C7.95764 11.9673 7.75016 12.087 7.52576 12.087ZM7.52576 9.56929H3.13076C2.96343 9.57027 2.80271 9.50459 2.684 9.38673C2.56541 9.26875 2.49863 9.10842 2.49863 8.94107C2.49863 8.77374 2.56541 8.6134 2.684 8.49541C2.80272 8.37755 2.96342 8.31175 3.13076 8.31286H7.52576C7.69309 8.31175 7.85391 8.37755 7.97252 8.49541C8.09124 8.61339 8.1579 8.77373 8.1579 8.94107C8.1579 9.10841 8.09124 9.26875 7.97252 9.38673C7.85393 9.50459 7.6931 9.57027 7.52576 9.56929Z"
                  fill="#87888C"
                ></path>
              </svg>
              AI Metin Yazarı
            </Link>
          </li>
          <li>
            <Link
              to=""
              className={active ? "active" : ""}
              onClick={() => setActive(!active)}
            >
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="sidebar-menu__icons"
              >
                <path
                  d="M1.43787 9.72L1.43793 9.71802C1.43999 9.64704 1.46986 9.58122 1.51879 9.53456C1.56748 9.48813 1.63102 9.46429 1.69518 9.46619C1.75936 9.4681 1.82165 9.4957 1.86781 9.5452C1.91402 9.59476 1.94003 9.66216 1.93818 9.73288C1.87654 11.6284 2.47948 13.4858 3.64177 14.9768C4.80448 16.4683 6.45241 17.4973 8.29499 17.8801C10.1377 18.2629 12.0546 17.9744 13.7065 17.0663C15.3582 16.1583 16.6376 14.6898 17.3202 12.9219C18.0027 11.1542 18.045 9.19966 17.4398 7.40349C16.8346 5.60721 15.6201 4.08363 14.0095 3.10339C12.3988 2.12305 10.4963 1.74984 8.63871 2.05065C6.78121 2.35146 5.0901 3.30654 3.86372 4.74525L3.85887 4.75095L3.85415 4.75677L3.62299 5.04208L2.83084 6.01979H4.08918H6.1953L6.2652 6.02464C6.31852 6.03483 6.36824 6.06298 6.40579 6.10631C6.44656 6.15337 6.4699 6.21495 6.4699 6.27974C6.4699 6.34453 6.44656 6.40611 6.40579 6.45317C6.36872 6.49595 6.31978 6.52393 6.26723 6.53444L6.19828 6.53854H2.27017L2.20315 6.53456C2.15668 6.52482 2.11306 6.50137 2.07808 6.46594C2.04211 6.42951 2.01715 6.38225 2.00732 6.33007L2.00249 6.25883V1.71638L2.0073 1.64623C2.01711 1.59399 2.04208 1.54667 2.07808 1.51022C2.11306 1.47478 2.15668 1.45134 2.20315 1.4416L2.25235 1.43867L2.30155 1.4416C2.34802 1.45134 2.39164 1.47478 2.42662 1.51022C2.46262 1.54667 2.48759 1.59399 2.4974 1.64623L2.5022 1.71622L2.50108 3.93335L2.50026 5.53706L3.55353 4.32771C5.00651 2.65942 7.04428 1.63137 9.23296 1.45984L9.18608 0.861672L9.23376 1.45978C10.9413 1.32365 12.65 1.71494 14.1337 2.58255C15.6175 3.45021 16.8069 4.75367 17.5435 6.32137C18.2801 7.88914 18.5288 9.64662 18.2562 11.361C17.9836 13.0753 17.2028 14.6647 16.0181 15.919C14.8336 17.1733 13.3011 18.0334 11.6241 18.3868C9.94707 18.7401 8.20341 18.5703 6.62352 17.8996C5.04356 17.2287 3.70112 16.0881 2.77469 14.6276C1.84822 13.1669 1.38179 11.4556 1.43787 9.72ZM9.44014 6.09355C9.47512 6.05811 9.51874 6.03467 9.56521 6.02493L9.62034 6.02165L9.66158 6.02451C9.70881 6.03399 9.75319 6.0576 9.78869 6.09355C9.82468 6.13 9.84965 6.17732 9.85946 6.22956L9.86427 6.2997V9.99969V10.5993L10.4639 10.5997L12.4263 10.6008L12.4944 10.6055C12.5471 10.6161 12.5961 10.6443 12.6332 10.6873C12.6737 10.7343 12.6969 10.7956 12.6969 10.8602C12.6969 10.9248 12.6737 10.9862 12.6332 11.0332C12.5961 11.0761 12.5471 11.1043 12.4944 11.1149L12.4265 11.1196H9.63521L9.56717 11.1149C9.51997 11.1054 9.47562 11.0818 9.44012 11.0459C9.40427 11.0097 9.37932 10.9627 9.36938 10.9107L9.36455 10.8389V6.2997L9.36936 6.22956C9.37917 6.17732 9.40414 6.13 9.44014 6.09355Z"
                  fill="#87888C"
                />
              </svg>
              Geçmiş
            </Link>
          </li>
        </ul>
      </div>
      <div className="section content-main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="row justify-content-center">
                <OptionMenu />
                <TextArea />
                <MultipleSelect />
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Yaratıcılık Seçimi</label>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Konu Başlığı"
                  >
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                  </DropdownButton>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Varyant Sayısı</label>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Konu Başlığı"
                  >
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                    <Dropdown.Item href="#/action-1">option</Dropdown.Item>
                  </DropdownButton>
                </div>
                <div className="col-md-4">
                  <input
                    type="submit"
                    className="submit-btn"
                    value="Sonuç Bul"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="rich-text-content">
                <RichTextEditor />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentMain;
